export const CUSTOM_DIMENSION_USER_TYPE_ID = 1;
export const CUSTOM_DIMENSION_USER_TYPE_USER = 'user';
export const CUSTOM_DIMENSION_USER_TYPE_EDITOR = 'editor';
export const TRACKING_DELAY = 100;

/*
 * Matomo event categories and actions
 */

/* Workbook */
export const EVENT_CATEGORY_WORKBOOK = 'Workbook';
export const SAVE_SEARCH = 'Save search';
export const BOOKMARK_INTERVIEW = 'Bookmark interview';
export const BOOKMARK_SEGMENT = 'Bookmark segment';
export const EDIT_WORKBOOK_ITEM = 'Edit workbook item';
export const REMOVE_WORKBOOK_ITEM = 'Remove workbook item';

/* Player */
export const EVENT_CATEGORY_PLAYER = 'Player';
export const PLAY = 'Play';
export const PAUSE = 'Pause';

/* Map */
export const EVENT_CATEGORY_MAP = 'Map';
export const VIEW_LOCATION_DETAILS = 'View location details';

/* Index */
export const EVENT_CATEGORY_INDEX = 'Index';
export const VIEW_INDEX_ENTRY = 'View index entry';
export const GO_TO_INDEXED_INTERVIEW = 'Go to indexed interview';

/* Interview */
export const EVENT_CATEGORY_INTERVIEW = 'Interview';
export const SWITCH_TAB = 'Switch tab';
export const SEARCH_INTERVIEW = 'Search interview';
export const GO_TO_TOC_ENTRY = 'Go to TOC entry';
export const GO_TO_TRANSCRIPT_SEGMENT = 'Go to transcript segment';
export const GO_TO_INDEXED_SEGMENT = 'Go to indexed segment';
export const COPY_URL = 'Copy URL';
